import * as React from 'react'

import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'

import SelectField from 'modules/core/components/SelectField'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

export interface OwnerData {
  id: string
  avatar?: string | null
  fullName: string
}

interface Props {
  owner: OwnerData
}

function Owner({ owner }: Props) {
  const dummyValue = 'owner'
  const option = [
    {
      label: i18n.t('custom_reports.share.modal.owner'),
      value: dummyValue,
    },
  ]

  return (
    <Box flexDirection="row" alignItems="center" justifyContent="flexStart">
      <Avatar size="s32" url={buildUrl(owner.avatar)} label={owner.fullName} />
      <Box minWidth="none" paddingLeft="s8" paddingRight="s16" flexGrow>
        <Text size="300" weight="medium" color="grey1000" ellipsis>
          {owner.fullName}
        </Text>
      </Box>
      <Box width="s140" flexGrow={false} flexNoShrink maxWidth="s140">
        <SelectField options={option} value={dummyValue} readonly />
      </Box>
    </Box>
  )
}

export default Owner
